import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-avatar",
  "use": "icon-user-avatar-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"#e8f0fe\" stroke=\"#4a90e2\" stroke-width=\"1\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-user-avatar\">\n  <circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"#e8f0fe\" />\n  <circle cx=\"12\" cy=\"9\" r=\"3\" />\n  <path d=\"M12 12a5 5 0 0 0-5 5 1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 5 5 0 0 0-5-5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol